import React, { useState } from 'react';
import { InboxOutlined } from '@ant-design/icons';
import { message, Upload, Card, Progress, Alert, Button } from 'antd';
import type { UploadProps } from 'antd';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';

const { Dragger } = Upload;

const UploadPage: React.FC = () => {
  const [uploading, setUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploadedContract, setUploadedContract] = useState<any>(null);
  const navigate = useNavigate();

  const handleUpload: UploadProps['customRequest'] = async (options) => {
    const { file, onSuccess, onError } = options;
    
    setUploading(true);
    setUploadProgress(0);
    
    const formData = new FormData();
    formData.append('file', file);
    
    try {
      // 模拟上传进度
      const interval = setInterval(() => {
        setUploadProgress(prev => {
          if (prev >= 90) {
            clearInterval(interval);
            return 90;
          }
          return prev + 10;
        });
      }, 200);
      
      const response = await api.post('/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      
      clearInterval(interval);
      setUploadProgress(100);
      setUploadedContract(response.data);
      
      message.success('上传成功！');
      onSuccess?.(response.data);
    } catch (error) {
      message.error('上传失败，请重试');
      onError?.(error as Error);
    } finally {
      setUploading(false);
    }
  };

  const startAudit = async () => {
  if (!uploadedContract) return;
  
  const hide = message.loading('正在审核合同...', 0);
  
  try {
    const response = await api.post(`/audit/${uploadedContract.id}`, null, {
      timeout: 120000,  // 单独设置此请求超时 120 秒
    });
    hide();
    message.success('审核完成');
    navigate(`/audit/${uploadedContract.id}`);
  } catch (error: any) {
    hide();
    // 如果错误是超时，但后端可能已完成，可提示用户稍后查看
    if (error.code === 'ECONNABORTED' || error.message?.includes('timeout')) {
      message.warning('审核处理中，请稍后前往合同管理查看结果');
      navigate('/contracts');
    } else {
      message.error('审核失败，请重试');
    }
  }
};

  return (
    <div>
      <h1 style={{ marginBottom: 24 }}>上传合同</h1>
      
      <Card>
        <Dragger
          name="file"
          multiple={false}
          accept=".doc,.docx,.pdf,.jpg,.jpeg,.png,.txt"
          customRequest={handleUpload}
          showUploadList={false}
          disabled={uploading}
        >
          <p className="ant-upload-drag-icon">
            <InboxOutlined />
          </p>
          <p className="ant-upload-text">点击或拖拽文件到此区域上传</p>
          <p className="ant-upload-hint">
            支持单次上传一个合同文件，支持格式：Word、PDF、图片、TXT
          </p>
        </Dragger>
        
        {uploading && (
          <div style={{ marginTop: 24 }}>
            <Progress percent={uploadProgress} status="active" />
          </div>
        )}
        
        {uploadedContract && !uploading && (
          <Alert
            style={{ marginTop: 24 }}
            message="上传成功"
            description={`文件：${uploadedContract.title}`}
            type="success"
            showIcon
            action={
              <Button size="small" type="primary" onClick={startAudit}>
                开始审核
              </Button>
            }
          />
        )}
      </Card>
    </div>
  );
};

export default UploadPage;